import awsRumActionNames from '../consts/aws/awsRumActionNames';
import awsRumActionTypes from '../consts/aws/awsRumActionTypes';
import {showCredentialsModal} from '../state/slice/modal';
import {dispatch} from '../state/store';
import uaUtils from '../utils/uaUtils';
import rumCustomEvents from './events/rumCustomEvents';
import storageService from './storageService';

const openIqosUrl = (url, isDarkStyleOnly) => {
    const isPopupHidden = storageService.getIsCredentialsPopupHidden();

    if (isPopupHidden) {
        openUrl(url);
    } else {
        dispatch(showCredentialsModal({url, isDarkStyleOnly}));
    }
};

const openUrl = (url) => {
    rumCustomEvents.recordAction({action: awsRumActionTypes.NAVIGATE, rumActionName: awsRumActionNames.LINK, url});
    window.open(url, '_blank');
};

const openPDFUrl = (url) => {
    const isIOSSafari26 = uaUtils.checkIsIOSSafari26();

    // Open PDF in a new window using an <embed> to show navigation controls in iOS PWA
    if (isIOSSafari26) {
        rumCustomEvents.recordAction({action: awsRumActionTypes.NAVIGATE, rumActionName: awsRumActionNames.LINK, url});
        const pdf = window.open('');

        pdf.document.title = 'IQOS App PDF';
        pdf.document.body.style.margin = '0';
        pdf.document.body.innerHTML = `
        <embed 
            src="${url}" 
            style="width:100%; height:100%; border:none;"
            type="application/pdf"
        ></embed>
        `;
        return;
    }

    openUrl(url);
};

export {openIqosUrl, openPDFUrl, openUrl};
